import { render, staticRenderFns } from "./transferencias.view.vue?vue&type=template&id=214a7b87"
import script from "./transferencias.view.vue?vue&type=script&lang=js"
export * from "./transferencias.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports